var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgTemVe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2726_24092)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 14,
    rx: 2,
    fill: "#A1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2673 0H1.73267C0.773039 0 0 0.77268 0 1.73187V12.1018C0 13.0556 0.773039 13.8336 1.73267 13.8336H5.44326V11.8726H1.96192V1.96101H40.0327V11.8673H36.3755V13.8283H40.262C41.2163 13.8283 41.9947 13.0556 41.9947 12.0964V1.73187C41.9947 0.778009 41.2216 0 40.262 0H40.2673Z",
    fill: "#00ACEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7228 34.291V6.02158H7.27197V34.291V41L10.0176 38.3782L12.7632 41L15.5088 38.3782L18.2545 41L21.0001 38.3782L23.7457 41L26.4913 38.3782L29.2369 41L31.9772 38.3782L34.7228 41V34.291Z",
    fill: "#4570FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 33.9415V16.0585C29 15.4763 29.45 15 30 15C30.55 15 31 15.4763 31 16.0585V33.9415C31 34.5237 30.55 35 30 35C29.45 35 29 34.5237 29 33.9415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 15.981C27 15.4392 26.5523 15 26 15C25.4477 15 25 15.4392 25 15.981V22.019C25 22.5608 25.4477 23 26 23C26.5523 23 27 22.5608 27 22.019V15.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 15.981C23 15.4392 22.5523 15 22 15C21.4477 15 21 15.4392 21 15.981V22.019C21 22.5608 21.4477 23 22 23C22.5523 23 23 22.5608 23 22.019V15.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 27.1036C27 26.4941 26.5523 26 26 26C25.4477 26 25 26.4941 25 27.1036V33.8964C25 34.5059 25.4477 35 26 35C26.5523 35 27 34.5059 27 33.8964V27.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 27.1036C23 26.4941 22.5523 26 22 26C21.4477 26 21 26.4941 21 27.1036V33.8964C21 34.5059 21.4477 35 22 35C22.5523 35 23 34.5059 23 33.8964V27.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9848 12.0325C11.5423 12.0325 11.1851 11.6755 11.1851 11.2332V9.62386C11.1851 9.18157 11.5423 8.82454 11.9848 8.82454C12.4273 8.82454 12.7844 9.18157 12.7844 9.62386V11.2332C12.7844 11.6755 12.4273 12.0325 11.9848 12.0325Z",
    fill: "#FFDD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5888 12.0325C15.1463 12.0325 14.7891 11.6755 14.7891 11.2332V9.62386C14.7891 9.18157 15.1463 8.82454 15.5888 8.82454C16.0313 8.82454 16.3885 9.18157 16.3885 9.62386V11.2332C16.3885 11.6755 16.0313 12.0325 15.5888 12.0325Z",
    fill: "#FFDD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1981 12.0325C18.7556 12.0325 18.3984 11.6755 18.3984 11.2332V9.62386C18.3984 9.18157 18.7556 8.82454 19.1981 8.82454C19.6406 8.82454 19.9978 9.18157 19.9978 9.62386V11.2332C19.9978 11.6755 19.6406 12.0325 19.1981 12.0325Z",
    fill: "#FFDD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8021 12.0325C22.3596 12.0325 22.0024 11.6755 22.0024 11.2332V9.62386C22.0024 9.18157 22.3596 8.82454 22.8021 8.82454C23.2446 8.82454 23.6018 9.18157 23.6018 9.62386V11.2332C23.6018 11.6755 23.2446 12.0325 22.8021 12.0325Z",
    fill: "#FFDD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4061 12.0325C25.9636 12.0325 25.6064 11.6755 25.6064 11.2332V9.62386C25.6064 9.18157 25.9636 8.82454 26.4061 8.82454C26.8486 8.82454 27.2058 9.18157 27.2058 9.62386V11.2332C27.2058 11.6755 26.8486 12.0325 26.4061 12.0325Z",
    fill: "#FFDD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.015 12.0325C29.5725 12.0325 29.2153 11.6755 29.2153 11.2332V9.62386C29.2153 9.18157 29.5725 8.82454 30.015 8.82454C30.4575 8.82454 30.8147 9.18157 30.8147 9.62386V11.2332C30.8147 11.6755 30.4575 12.0325 30.015 12.0325Z",
    fill: "#FFDD64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 33.8889V16.1111C11 15.4974 11.5469 15 12.2282 15H16.7718C17.4483 15 18 15.4974 18 16.1111V33.8889C18 34.5026 17.4531 35 16.7718 35H12.2282C11.5517 35 11 34.5026 11 33.8942V33.8889Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2726_24092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 41,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTemVe);
export default __webpack_public_path__ + "static/media/img_tem_ve.5a5d0815887eb644dd8cb27849896ac5.svg";
export { ForwardRef as ReactComponent };